/** Internal team inboxes for provider-facing “contact us” flows. */

export const TEAM_CONTACT_EMAILS = Object.freeze([
  'lukewilliams@nkyconnect.com',
  'chandlerfarmer@nkyconnect.com',
]);

export function teamContactMailtoHref(options = {}) {
  const { subject, body } = options;
  const to = TEAM_CONTACT_EMAILS.join(',');
  // Use encodeURIComponent (spaces → %20), not URLSearchParams (+), so subjects aren’t shown as "NKY+Connect:+..."
  const parts = [];
  if (subject) parts.push(`subject=${encodeURIComponent(subject)}`);
  if (body) parts.push(`body=${encodeURIComponent(body)}`);
  const query = parts.join('&');
  return query ? `mailto:${to}?${query}` : `mailto:${to}`;
}

export const TEAM_CONTACT_EMAILS_OR_DISPLAY = TEAM_CONTACT_EMAILS.join(' or ');

export const ACCOUNT_EMAIL_CHANGE_HELPER_TEXT = `To change your email, please contact ${TEAM_CONTACT_EMAILS_OR_DISPLAY}`;
